import React, { Component } from 'react';
import axios from 'axios';
import '../../Asset/Css/Site.css';
import 'react-notifications-component/dist/theme.css'
import { Card, Row, Col, InputGroup, FormControl, Modal, Button } from 'react-bootstrap';
import '../../Asset/Css/util.css';
import '../../Asset/Css/main.css';
import { config } from '../../Constants';
import { store } from 'react-notifications-component';
import ReactNotification from 'react-notifications-component';
import global from '../global';
import Spinner from '../Spinner';
import EasyDividendLogo from '../../Asset/Images/easy-dividend-logo.png';
import goBack from '../../Asset/Images/previous-icon.png';

export class SignUp extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            openOTPConsentModal: false,
            isVerified: false,
            DPID: '',
            Email: '',
            Password: '',
            ConfirmPassword: '',
            shareholdername:'',
            PAN: '',
            userType: '',
            OTP:'',
            demo: false,
            showRegisterDetails: 'block',
            showValidateOTP: 'none',
            showTiming: 'none',
            showReOTP: 'none',
            time: {},
            seconds: 300,
            loading: false,
            URL: config.url.Web_URL
        };
        this.initialState = this.state;

        this.handleChange = this.handleChange.bind(this);
        this.handleUserType = this.handleUserType.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleValidate = this.handleValidate.bind(this);
        this.handleSendOTP = this.handleSendOTP.bind(this);
        this.timer = 0;
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
        
    }

    closeModal = () => {
        this.setState({ isOpen: false })

        window.location.href = config.url.Web_URL + '/SignIn';
    };

    showNoti(title, message, type) {
        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });
    };

    secondsToTime(secs) {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    startTimer() {
        if (this.timer == 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    countDown() {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;
        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
        });

        // Check if we're at zero.
        if (seconds == 0) {
            clearInterval(this.timer);
            this.setState({ showReOTP: 'block', showTiming: 'none' });
        }
    }

    handleUserType = e => {
        debugger
        const { name, value } = e.target;

        this.setState({
            [name]: value
        });

        console.log(this.state.userType);
    };

    handleChange(e) {
        debugger
        const { name, value } = e.target;
        this.setState({ [name]: value });

    }

    handleSubmit = (e) => {
        debugger

        if (this.state.DPID == "" || this.state.DPID == null) {
            this.showNoti("Notification", "DP ID/Folio ID is required.", "warning");
            return;
        }

        if (this.state.Email == "" || this.state.Email == null) {
            this.showNoti("Notification", "Email is required.", "warning");
            return;
        }

        if (this.state.Password == "" || this.state.Password == null) {
            this.showNoti("Notification", "Password is required.", "warning");
            return;
        }

        if (this.state.Password.length < 8) {
            this.showNoti("Notification", "Your password must be at least 8 characters", "danger");
            return;
        }

        if (this.state.Password.search(/[a-z]/i) < 0) {
            this.showNoti("Notification", "Your password must contain at least one letter.", "danger");
            return;
        }

        if (this.state.Password.search(/[0-9]/) < 0) {
            this.showNoti("Notification", "Your password must contain at least one digit.", "danger");
            return;
        }
        if (this.state.Password.search(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/) < 0) {
            this.showNoti("Notification", "Your password must contain at least one special character.", "danger");
            return;
        }

        if (this.state.ConfirmPassword == "" || this.state.ConfirmPassword == null) {
            this.showNoti("Notification", "Confirm Password is required.", "warning");
            return;
        }

        if (this.state.Password != this.state.ConfirmPassword) {
            this.showNoti("Notification", "Password & Confirm Password should match.", "danger");
            return;
        }

        if (this.state.Email !== "") {
            var regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

            if (!regex.test(this.state.Email)) {
                this.showNoti("Notification", "Invalid Email Address.", "danger");
                return;
            }
        }

        this.setState({
            openOTPConsentModal: true
        });
    }

    handleSendOTP = (e) => {

        this.setState({
            openOTPConsentModal: false
        });

        const sendOTPEmail = this.state;

        axios.post(global.UserManagement.SendOTPEmailAPI, sendOTPEmail)
            .then(json => {
                if (json.data.status) {
                    this.setState({
                        showValidateOTP: 'block',
                        showRegisterDetails: 'none'
                    });
                    //this.timer = setInterval(this.countDown, 1000);
                    /*              this.setState({ showTiming: 'block', time: {}, seconds: 300});*/
                    this.showNoti("Notification", "OTP sent successfully; check on your entered email.", "success");
                    this.timer = setInterval(this.countDown, 1000);
                    this.setState({ showTiming: 'block', showReOTP: 'none', time: {}, seconds: 300});
                }
                else {
                    this.setState({
                        showValidateOTP: 'none',
                        showRegisterDetails: 'block'
                    });

                    this.showNoti("Notification", json.data.message, "danger");
                }
            })

    }

    closeOTPConsentModal = () => {
        this.setState({ openOTPConsentModal: false })

        //window.location.href = config.url.Web_URL + '/SignIn';
    };

    handleValidate(e) {

        if (this.state.OTP == '') {
            this.showNoti("Notification", "Please enter OTP.", "danger");
            return;
        }

        if (isNaN(this.state.OTP))
        {
            this.showNoti("Notification", "Invalid OTP.", "danger");
            return;
        }

        this.setState({ loading: true });

        const OTP = this.state;
        axios.post(global.UserManagement.ValidateOTPNewAPI, OTP)
            .then(json => {
                if (json.data.status) {
                    this.setState({
                        isOpen: true,
                        showTiming: 'none',
                        showReOTP: 'none',
                        loading: false 
                    });
                }
                else {
                    this.setState({ loading: false });
                    this.showNoti("Notification", json.data.message, "danger");
                }
            });
    }

    handleCancel = (e) => {
        e.preventDefault();
        window.location.href = config.url.Web_URL;
    }

    render() {

        if (this.state.loading) return <Spinner />;

        return (
            <div>
                <ReactNotification />

                <div className="main-bg">
                    <img src={EasyDividendLogo} alt="Logo" className="logo-img" />
                    <div className="sub-main-w3">
                        <div className="image-style">

                        </div>

			            <div className="vertical-tab">
                            <a href={this.state.URL + "/SignIn"} className="section-w3ls">
                                <input type="radio" name="sections" id="option1" onClick={this.state.URL + "/SignIn"} />
                                    <label className="icon-left-w3pvt"><span className="fa fa-user-circle" aria-hidden="true"></span>Sign In</label>
				            </a>
                            <div className="section-w3ls">
                                <input type="radio" name="sections" id="option2" onClick={this.state.URL + "/SignUp"} checked />
                                    <label for="option2" className="icon-left-w3pvt"><span className="fa fa-pencil-square" aria-hidden="true"></span>Sign Up</label>
                                    <article>
                                    <div className="form h-430" >
                                        <h3 className="legend">Sign Up</h3>
                                        <Row>
                                            <Col md={12}>
                                                <label className="required-field m-t-20">DP ID/Folio ID</label>
                                                <FormControl type="text" name="DPID" key="txtDPID" className="m-t-10"
                                                    value={this.state.DPID}
                                                    onChange={this.handleChange}
                                                    placeholder="Max 16 Characters"
                                                    maxLength="16"
                                                />
                                            </Col>
                                            <Col md={12}>
                                                <label className="required-field m-t-20">Email</label>
                                                <FormControl type="email" name="Email" key="txtEmail" className="m-t-10" 
                                                    value={this.state.Email}
                                                    onChange={this.handleChange}
                                                    placeholder="Max 100 Characters"
                                                    maxLength="100"
                                                    autoCompleteto="off"
                                                />
                                            </Col>
                                            
                                            <Col md={6} style={{ display: `${this.state.showRegisterDetails}` }}>
                                                <label className="required-field m-t-20">Password</label>
                                                <FormControl type="password" name="Password" className="m-t-10" maxLength="100"
                                                    value={this.state.Password}
                                                    onChange={this.handleChange}
                                                    placeholder="Max 50 Characters"
                                                    autoCompleteto="off"
                                                />
                                            </Col>
                                            <Col md={6} style={{ display: `${this.state.showRegisterDetails}` }}>
                                                <label className="required-field m-t-20">Confirm Password</label>
                                                <FormControl type="password" name="ConfirmPassword" className="m-t-10" maxLength="50"
                                                    value={this.state.ConfirmPassword}
                                                    onChange={this.handleChange}
                                                    placeholder="Max 50 Characters"
                                                    autoCompleteto="off"
                                                />
                                            </Col>
                                            <Col md={12} style={{ display: `${this.state.showValidateOTP}` }}>
                                                <label className="required-field m-t-20">OTP</label>
                                                <FormControl type="text" name="OTP" className="m-t-10"
                                                    value={this.state.OTP}
                                                    onChange={this.handleChange}
                                                    placeholder="Format: 123456"
                                                    maxLength="6"
                                                    autoCompleteto="off"
                                                />
                                            </Col>
                                            <Col md={12} className="m-t-20" style={{ display: `${this.state.showRegisterDetails}` }}>
                                                <button type="submit" className="btn submit last-btn" onClick={this.handleSubmit}>Submit</button>
                                            </Col>
                                            <Col md={12} className="m-t-20" style={{ display: `${this.state.showValidateOTP}` }}>
                                                <button type="submit" className="btn submit last-btn" onClick={this.handleValidate}>Validate</button>
                                            </Col>

                                            <Col md={12} className="m-t-20 text-center" style={{ display: `${this.state.showTiming}` }}>
                                                <button> Time Remaining: {this.state.time.m} : {this.state.time.s}  </button>
                                            </Col>
                                            <Col md={12} className="m-t-20 text-center" style={{ display: `${this.state.showReOTP}` }}>
                                                <button onClick={this.handleSubmit}> Click Here to Re-Generate OTP  </button>
                                            </Col>

                                        </Row>

                                        <Row>
                                            <Modal show={this.state.openOTPConsentModal} onHide={this.closeOTPConsentModal}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title className="modal_title">OTP</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body className="modal_body">
                                                    One Time Password will be send to above entered email address. 
                                                 </Modal.Body>
                                                <Modal.Footer>
                                                    <Button class="btn btn-primary float-right m-r-10 m-b-10" variant="primary" onClick={this.handleSendOTP}>
                                                        Send OTP
                                                </Button>
                                                    <Button variant="dark" onClick={this.closeOTPConsentModal}>
                                                        Cancel
                                                    </Button>
                                                   
                                                </Modal.Footer>
                                            </Modal>
                                        </Row>


                                        <Row>
                                            <Modal show={this.state.isOpen} onHide={this.closeModal}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title className="modal_title">Notification</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body className="modal_body">
                                                    User profile created successfuly.
                                                </Modal.Body>
                                                <Modal.Footer>
                                                    <Button variant="dark" onClick={this.closeModal}>
                                                        Close
                                                    </Button>
                                                </Modal.Footer>
                                            </Modal>

                                        </Row>

                                        {/*<div className="m-login__account" style={{ display: `${this.state.showTiming}` }}>*/}
                                        {/*    <button className="m-link m-link--light m-login__account-link" > Time Remaining: {this.state.time.m} : {this.state.time.s}  </button>*/}
                                        {/*</div>*/}
                                    
                                            
                                      
                                    </div>

                                </article>
				            </div>
                            <a href={this.state.URL + "/ResetPassword"} className="section-w3ls">
                                <input type="radio" name="sections" onClick={this.state.URL + "/ResetPassword"} />
                                    <label className="icon-left-w3pvt"><span className="fa fa-lock" aria-hidden="true"></span>Forgot Password</label>
				            </a>
                        </div>
			            <div className="clear"></div>
                        <img src={goBack} class="go_back" onClick={this.handleCancel} alt="Go to previous page" title="Go to previous page" />


                    </div>
                </div>
            </div>
        );
    }
}